/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Background from "../../components/Background";
import useValidation from "../../hooks/useValidation";
import {
  Button,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
  Box,
} from "@mui/material";
import { VisibilityOff, Visibility } from "@mui/icons-material";
import { styled } from "@mui/system";
import { clearResetPasswordData, resetPassword } from "../../redux/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Topnav from "../../components/Topnav";
import tickmark from "../../assets/images/Tick Mark.svg";
import tickmarkSolid from "../../assets/images/check-solid.png";
import Copyrighttext from "../../components/Copyrighttext";
import ArrowBackIcon from "../../assets/images/Arrow Left.svg"; // Import back arrow icon
import "./NewPassword.css";

const StyledIconButton = styled(IconButton)({
  width: "40px",
  height: "40px",
  color: "#7BB9D5",

  borderRadius: "50%", // Make it circular
  "&:hover": {
    backgroundColor: "#E0E7E9", // Slightly darker on hover
  },
});
const RoundedTextField = styled(TextField)(() => ({
  borderRadius: "20px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "20px",
    backgroundColor: "#F1F7FA",
  },
  "& .MuiInputBase-input": {
    padding: "10px",
    color: "#2A4876", // Set the input value color to green
    "&::placeholder": {
      color: "#151516", // Set the placeholder text color to red
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent",
  },
  // Ensure text color stays the same when focused or filled
  "& .MuiInputBase-input:focus": {
    color: "#2A4876", // Set color when focused (same as default)
  },
  "& .MuiInputBase-input.Mui-filled": {
    color: "#2A4876", // Set color for filled text (same as default)
  },
}));

const validationArr = [
  {
    name: "specialChar",
    text: `1 special character (Any)`,
  },
  {
    name: "uppercase",
    text: `1 uppercase letter (A - Z)`,
  },
  {
    name: "number",
    text: `1 number (0 - 9)`,
  },
  {
    name: "minLength",
    text: `Minimum 8 characters long`,
  },
];

export default function NewPassword() {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  const [showRetypePassword, setShowRetypePassword] = useState(false);
  const [formValues, setFormValues] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const { errors, validateInputs, resetValidation } = useValidation({
    newPassword: formValues.newPassword,
    confirmPassword: formValues.confirmPassword,
  });
  const [validations, setValidations] = useState({
    specialChar: false,
    uppercase: false,
    number: false,
    minLength: false,
  });

  const validatePassword = (password) => {
    setValidations({
      specialChar: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password), // Check special char (@, -, $)
      uppercase: /[A-Z]/.test(password), // Check for uppercase letter
      number: /\d/.test(password), // Check for number
      minLength: password.length >= 8, // Check minimum length
    });
  };

  useEffect(() => {
    if (auth.resetPwdStatus === "failed") {
      dispatch(clearResetPasswordData());
    }
  }, []);

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleToggleRetypePasswordVisibility = () => {
    setShowRetypePassword((prev) => !prev);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    name === "newPassword" && validatePassword(value);
    if (auth.resetPwdStatus === "failed") {
      dispatch(clearResetPasswordData());
    }
    if (errors) {
      resetValidation();
    }
  };

  const handleResetPassword = () => {
    if (!validateInputs()) {
      return;
    }
    const payload = {
      newPassword: formValues.newPassword,
      confirmPassword: formValues.confirmPassword,
      // Optional: this screen is reachable by reload, which carries no router
      // state. Dereferencing threw only on submit, so the form rendered and
      // then failed when used.
      token: location.state?.token,
    };
    dispatch(resetPassword(payload))
      .then((response) => {
        if (response?.payload?.status) {
          navigate("/login");
        }
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  };

  // Button disabled state based on input values
  const disable =
    auth.resetPwdStatus === "loading" ||
    !(formValues.newPassword && formValues.confirmPassword);

  return (
    <Background>
      <Topnav />
      <IconButton
        onClick={() => navigate(-1)}
        sx={{
          display: { xs: "flex", lg: "none" }, // Show on xs, sm, md, and hide on lg and up
          alignItems: "center !important",
          position: "relative",
          bgcolor: "#2A4876",
          color: "white",
          borderRadius: "20px", // Make it rounded
          padding: "8px 16px !important", // Adjust padding to get the pill shape
          "&:hover": { bgcolor: "#1F3553" },
          marginX: "20px",
          marginTop: "10px",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", marginRight: "8px" }}>
          <img src={ArrowBackIcon} alt="Back" />
        </Box>
        <Typography
          sx={{ fontWeight: "bold", fontSize: "14px", fontFamily: "PTSans" }}
        >
          Back
        </Typography>
      </IconButton>
      {/* Back Button in large devices */}
      <IconButton
        onClick={() => navigate(-1)}
        sx={{
          display: { xs: "none", sm: "none", md: "none", lg: "flex" }, // Hide on xs, sm, md, and show on lg and up
          alignItems: "center !important",
          position: "absolute",
          left: "15vw",
          bgcolor: "#2A4876",
          color: "white",
          borderRadius: "20px", // Make it rounded
          padding: "8px 16px !important", // Adjust padding to get the pill shape
          "&:hover": { bgcolor: "#1F3553" },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", marginRight: "8px" }}>
          <img src={ArrowBackIcon} alt="Back" />
        </Box>
        <Typography
          sx={{ fontWeight: "bold", fontSize: "14px", fontFamily: "PTSans" }}
        >
          Back
        </Typography>
      </IconButton>
      <div className="selection-box">
        <Typography
          className="text-primary text-xxl"
          variant="h5"
          sx={{ fontWeight: "700" }}
        >
          Enter New Password
        </Typography>
        <Typography
          variant="body1"
          className="body"
          sx={{
            fontWeight: 400,
            fontSize: "14px",
            color: "#152134",
          }}
        >
          Please do not share your password with anyone.
        </Typography>
        <Box>
          <Typography
            mt={1}
            className=" text-sm text-text-color"
            sx={{ fontWeight: 400, textAlign: "left" }}
          >
            New Password
          </Typography>
          <RoundedTextField
            name="newPassword"
            variant="outlined"
            placeholder="Enter your Password"
            fullWidth
            type={showPassword ? "text" : "password"}
            value={formValues.newPassword}
            error={!!errors.newPassword}
            helperText={<span className="error-msg">{errors.newPassword}</span>}
            onChange={handleChange}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <StyledIconButton onClick={handleTogglePasswordVisibility}>
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </StyledIconButton>
                  </InputAdornment>
                ),
              },
            }}
          />
        </Box>
        <Box>
          <Typography
            className=" text-sm text-text-color"
            sx={{ fontWeight: 400, textAlign: "left" }}
          >
            Confirm Password
          </Typography>
          <RoundedTextField
            name="confirmPassword"
            variant="outlined"
            placeholder="Retype Password"
            fullWidth
            type={showRetypePassword ? "text" : "password"}
            value={formValues.confirmPassword}
            error={!!errors.confirmPassword}
            helperText={
              <span className="error-msg">{errors.confirmPassword}</span>
            }
            onChange={handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <StyledIconButton
                    onClick={handleToggleRetypePasswordVisibility}
                  >
                    {showRetypePassword ? <Visibility /> : <VisibilityOff />}
                  </StyledIconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Box className="password-rules">
          <div className="password-rules">
            {validationArr?.map((item) => {
              return (
                <Typography
                  sx={{ marginBottom: "3px" }}
                  variant="body2"
                  className="text-xs text-text-color"
                  key={item?.text}
                >
                  {validations[item?.name] ? (
                    <img
                      alt=""
                      src={tickmarkSolid}
                      width={"14px"}
                      height={"14px"}
                      style={{ marginRight: "5px" }}
                    />
                  ) : (
                    <img
                      alt=""
                      src={tickmark}
                      width={"14px"}
                      height={"14px"}
                      style={{ marginRight: "5px" }}
                    />
                  )}{" "}
                  {item?.text}
                </Typography>
              );
            })}
          </div>
        </Box>

        {auth.resetPwdStatus === "failed" && (
          <Typography sx={{ color: "red", marginBottom: "15px" }}>
            {auth.resetPwdError}
          </Typography>
        )}

        <Button
          onClick={handleResetPassword}
          variant="contained"
          fullWidth
          className="Reset-button"
          sx={{
            height: {
              xs: "40px",
              sm: "45px",
              md: "45px",
              lg: "50px",
              xl: "60px",
            },
            borderRadius: "100px",
            textTransform: "capitalize",
          }}
          style={{
            backgroundColor: !disable ? "#2A4876" : "#AAB6C8", // Change color based on input values
            cursor: disable ? "pointer" : "not-allowed", // Disable hover effect when fields are not filled
          }}
        >
          Reset Password
        </Button>
      </div>
      <Box mt={2} sx={{ display: { xs: "block", sm: "none" } }}>
        <Copyrighttext />
      </Box>
      <Box
        sx={{
          display: { xs: "none", sm: "block" },
        }}
      >
        <Copyrighttext />
      </Box>
    </Background>
  );
}
